import { useMotionValue, useSpring } from "framer-motion";

// Returns props to give a motion element a subtle cursor-following 3D tilt.
export function useTilt(max = 7) {
  const rx = useMotionValue(0);
  const ry = useMotionValue(0);
  const rotateX = useSpring(rx, { stiffness: 200, damping: 18, mass: 0.4 });
  const rotateY = useSpring(ry, { stiffness: 200, damping: 18, mass: 0.4 });

  const onMouseMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width; // 0..1
    const py = (e.clientY - r.top) / r.height; // 0..1
    ry.set((px - 0.5) * 2 * max);
    rx.set(-(py - 0.5) * 2 * max);
  };
  const onMouseLeave = () => {
    rx.set(0);
    ry.set(0);
  };

  return {
    style: { rotateX, rotateY, transformPerspective: 900 },
    onMouseMove,
    onMouseLeave,
  };
}
